import axios from 'axios';

export default {
    list() {
        return axios.post('/paintshop/list/');
    },

    fetchOptions() {
        return axios.post('/paintshop/options/');
    },
};
